import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useMemo } from 'react';

import { bimWorkOrderVersionObjectsGql } from '../workOrderVersionQueries';

interface IUseBimWorkOrderObjects {
    withEffect?: boolean;
    requestKey?: string;
    workOrderVersionId: number;
}

export const useBimWorkOrderVersionObjects = (props: IUseBimWorkOrderObjects) => {
    const { withEffect = true, requestKey, workOrderVersionId } = props;

    const requestId = useMemo(() => `bimWorkOrderVersionObjects_${requestKey}`, [requestKey]);

    const [reset] = useResetStoreData({ requestId });

    const requestVariables = useMemo(
        () => ({
            workOrderVersionId,
        }),
        [workOrderVersionId],
    );

    const [bimWorkOrderVersionObjectsData, bimWorkOrderObjectsStatus, bimWorkOrderObjectsError] = useRequest({
        requestId,
        query: bimWorkOrderVersionObjectsGql,
        withEffect: withEffect && Boolean(workOrderVersionId),
        variables: requestVariables,
    });

    const data = useMemo(
        () => bimWorkOrderVersionObjectsData?.bimWorkOrderVersionObjects,
        [bimWorkOrderVersionObjectsData?.bimWorkOrderVersionObjects],
    );

    return {
        reset,
        data,
        status: bimWorkOrderObjectsStatus,
        error: bimWorkOrderObjectsError,
    };
};
